// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2Cgih","upload":"Small_upload__88YWH","imageWrap":"Small_imageWrap__9JCwX","removeBtn":"Small_removeBtn__1tjdQ"};